import { cva } from "./index.ts";

export const checkbox = cva({
  base: "overflow-clip transition appearance-none box-content rounded-sm border border-primary align-bottom before:content-[' '] checked:bg-primary before:border-hazel-500 before:border-l-2 before:translate-y-4 before:transition checked:before:translate-y-0 before:bg-hazel-500 before:w-full before:h-full clip-checkmark flex items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
  variants: {
    size: {
      sm: "h-3 w-3",
      md: "h-4 w-4",
      lg: "h-5 w-5",
    },
  },
});
